import { classInstance } from '@/shared/helpers/helpers';
import { ModalGalleryMedia } from './modal-gallery-media/modal-gallery-media';

export class ModalGallery {
	private readonly mediaSelector = '.js-modal-gallery-media';

	constructor() {
		this.init();
	}

	public init = (): void => {
		Object.assign(window.app, { modalGallery: this });
		this.initSliders();
	};

	private initSliders = (): void => {
		document.querySelectorAll(this.mediaSelector).forEach((element) => {
			new ModalGalleryMedia(element as HTMLElement);
		});
	};

	public open = (selector: string, index: number | string = 0): void => {
		const slider = this.getSlider(selector);

		slider?.setOpenIndex(index);
		(window as any).app.modal.open(selector);
	};

	public getSlider = (selector: string): ModalGalleryMedia | undefined => {
		const element = document.querySelector(selector)?.querySelector(this.mediaSelector);

		if (!element) return undefined;

		return classInstance.get(element)?.modalGalleryMedia as ModalGalleryMedia | undefined;
	};

	public destroy = (): void => {
		delete window.app.modalGallery;
	};

	public reinit = (): void => {
		this.destroy();
		this.init();
	};
}
